export default __webpack_public_path__ + "static/media/M3_360_mobile.96c3b4b0.jpg";